import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout/default"

export default function ({ data }) {
  const post = data.markdownRemark
  return (
    <Layout title={post.frontmatter.title}>
      <div>
        <h1>{post.frontmatter.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
      }
    }
  }
`
